<script>
	export let width = '60px'
</script>

<img src="/asset_bolt.svg" alt="" {width} style="width:{width}; height:{width}" height={width} />
